import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import { ProgressBar } from 'primeng/progressbar';
import { LeakScoreStatus } from '@app/core/enums/leak-score-status.enum';

@Component({
  selector: 'gc-ld-logger-noise-score-ai-predictor',
  standalone: true,
  imports: [NgClass, TranslateDirective, ProgressBar],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-score-ai-predictor.component.html',
  host: {
    class: 'flex flex-col grow-1 gap-[0.5rem] self-end min-w-0',
  },
})
export class LdLoggerNoiseScoreAiPredictorComponent {
  public leakScore = input<number | undefined>();
  public leakScoreStatus = input<LeakScoreStatus | undefined>();
  public small = input<boolean>(false);

  protected readonly defaultColor = 'var(--p-gray-100)';

  public progressColor = computed(() => {
    switch (this.leakScoreStatus()) {
      case LeakScoreStatus.Critical:
        return 'var(--p-other-red-500)';
      case LeakScoreStatus.Warn:
        return 'var(--p-orange-500)';
      case LeakScoreStatus.Normal:
        return 'var(--p-other-green-500)';
      default:
        return this.defaultColor;
    }
  });
}
